import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface LoadingProps {
  /** Alias for message (same display). Prefer one of label / message. */
  label?: string;
  message?: string;
  className?: string;
}

export default function Loading({ label, message, className }: LoadingProps) {
  const { t } = useTranslation();
  const displayMessage = label ?? message ?? t("common.loading");

  return (
    <div className={`flex items-center justify-center h-full min-h-[400px] ${className || ""}`}>
      {/* ux-consistency: loading/empty C */}
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground">{displayMessage}</p>
      </div>
    </div>
  );
}
